import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import ContractingDetailSection from 'features/contracting/sections/ContractingDetailSection';

type RouteProps = {
  contractingId: string;
}

const ContractingDetailPage = () => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // router
  const { contractingId } = useParams<RouteProps>();

  // render
  return (
    <>
      <Header
        title={tLabels("contractingDetailPage.title")}
        includeBreadcrumbs
        links={[
          { to: "/contracting", text: tLabels("contracting.title") },
        ]}
      />
      <ModuleContent>
        <ContractingDetailSection 
          contractingId={contractingId} 
        />
      </ModuleContent>
    </>
  );
}

export default ContractingDetailPage;